/**
 * Badge - 상태/라벨 뱃지 컴포넌트
 *
 * @param variant - 색상 변형 (primary, success, warning, danger 등)
 * @param badgeStyle - 'soft' | 'filled' | 'outlined' 스타일
 * @param count - 숫자만 표시하는 원형 뱃지 모드 (children 없이 사용 시)
 */
'use client';

import React from 'react';
import { Check } from 'lucide-react';
import styles from './Badge.module.css';

export interface BadgeProps {
  variant?:
    | 'primary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'default'
    | 'blue'
    | 'teal'
    | 'purple'
    | 'pink'
    | 'orange';
  badgeStyle?: 'soft' | 'filled' | 'outlined';
  dot?: boolean;
  checkmark?: boolean;
  size?: 'sm' | 'md' | 'lg';
  count?: number;
  children?: React.ReactNode;
}

export default function Badge({
  variant = 'default',
  badgeStyle = 'soft',
  dot = false,
  checkmark = false,
  size = 'md',
  count,
  children,
}: BadgeProps) {
  // Count-only badge (numeric circular badge)
  if (count !== undefined && !children) {
    const countCls = [styles.countBadge, styles[variant], styles[badgeStyle], styles[size]]
      .filter(Boolean)
      .join(' ');

    return <span className={countCls}>{count}</span>;
  }

  const cls = [styles.badge, styles[variant], styles[badgeStyle], styles[size]]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls}>
      {dot && <span className={styles.dot} />}
      {checkmark && <Check size={12} className={styles.checkIcon} />}
      {children}
      {count !== undefined && <span className={styles.countInline}>{count}</span>}
    </span>
  );
}
